import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
	providedIn: 'root'
})
export class AliasService {

	constructor(
		private http: HttpService
	) { }

	getAll(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post('api/alias/alias/getAll', true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}
}
